import { Component, OnInit } from '@angular/core';
import { ChangeEmailCredentials } from '../../../common/models/change-email-credentials';
import { UtilitiesService } from '../../../common/shared/services/utilities.service';
import { AuthService } from '../../../common/shared/services/auth.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-change-email',
  templateUrl: './change-email.component.html',
  styleUrls: ['./change-email.component.scss']
})
export class ChangeEmailComponent implements OnInit {

  changeEmailCredentials: ChangeEmailCredentials;
  hidePW = true;

  constructor(
    private _dialogRef: MatDialogRef<ChangeEmailComponent>,
    private _authService: AuthService,
    private _utilitiesService: UtilitiesService) { }

  ngOnInit() {
    this.changeEmailCredentials = new ChangeEmailCredentials();
  }

  update() {
    this._utilitiesService.addMinorAction('ChangeEmail');
    this._authService.changeEmail(this.changeEmailCredentials).subscribe(
      data => {
        this._utilitiesService.removeAction('ChangeEmail');
        if (this._utilitiesService.getData(data)) {
          this._dialogRef.close('Success');
        } else {
          this._dialogRef.close('Error');
        }
      },
      err => {
        this._utilitiesService.handleErrors(err);
        this._dialogRef.close('Error');
      }
    );
  }

  updateActionActive() {
    return this._utilitiesService.isActionActive('ChangeEmail');
  }

}
